import type { PostHogConfig } from 'posthog-js';
import posthog from 'posthog-js';

import { environment } from '../environment/environment';

// https://posthog.com/docs/integrate/client/js#config
const options: Partial<PostHogConfig> = {
  api_host: 'https://app.posthog.com',
  disable_persistence: true,
  property_denylist: ['email', 'password', 'new_password', 'old_password', 'diary'],
};

if (environment.environment_deploy !== 'local') {
  posthog.init(environment.posthogToken, options);
}

export { posthog as posthogClient };
